import {
  primaryColors,
  transparentColors
} from '@assets/styles/helpers/colors.styles'

export const accordionstyles = {
  '.MuiPaper-root': {
    overflow: 'hidden'
  },

  background: transparentColors.whiteShade1,
  color: primaryColors.white,
  transition: 'background 0.3s',

  '.MuiAccordion-root': {
    boxShadow: 0
  },
  '.MuiAccordionSummary-root': {
    padding: '0 1rem !important',
    '&:focus': {
      outline: 'none !important'
    },
    '&:focus-visible': {
      outline: 'none !important'
    }
  },
  '.MuiAccordionSummary-content': {
    margin: '1rem 0 !important'
  },

  '&.MuiPaper-root': {
    borderRadius: '0.5rem',
    boxShadow: 'none',

    '&.Mui-expanded': {
      background: transparentColors.whiteShade1
    },
    '&:not(.Mui-expanded):hover': {
      background: transparentColors.whiteShade2
    },

    '.MuiAccordionSummary-root.Mui-expanded': {
      minHeight: '0 !important'
    }
  },
  '.MuiAccordionDetails-root': {
    padding: '0 1rem 1rem 1rem'
  },
  '&.MuiAccordion-root.Mui-expanded': {
    margin: '0'
  },
  '&.MuiPaper-root.MuiAccordion-root::before': {
    display: 'none'
  }
}

export const accordionDetailsStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '0.75rem'
}
